import { translate } from "../i18n";

var vlang = function (el, binding, vnode) {
    var lang = vnode.context.$root.lang;
    var term = binding.arg;
    var replaces = binding.value;
    var text = translate(term, lang, replaces);

    el.innerHTML = text;
};

export default {
    bind: function (el, binding, vnode) {
        vlang(el, binding, vnode);
    },
    update: function (el, binding, vnode) {
        vlang(el, binding, vnode);
    },
};
